{
  "title": "Manage Licenses",
  "loading": "Loading licenses...",
  "buyLicenses": "Buy Licenses",
  "product": "Product",
  "frequency": "Frequency",
  "paymentMethod": "Payment Method",
  "status": "Status",
  "nextInvoice": "Next invoice",
  "actions": "Actions",
  "annual": "Annual billing",
  "monthly": "Monthly billing",
  "manual": "Manual Billing",
  "cancelAtPeriodEnd": "Cancels on",
  "trialExpiresOn": "Trial expires on",
  "invoiceAmount": "for",
  "nextInvoiceOn": "Next invoice on",
  "manageSubscription": "Manage Subscription",
  "invoices": "Invoices",
  "loadingInvoices": "Loading invoices...",
  "noInvoices": "No invoices found",
  "download": "Download",
  "view": "View",
  "showing": "Showing",
  "of": "of",
  "previous": "Previous",
  "page": "Page",
  "next": "Next",
  "error": "Error",
  "errorFetchingInvoices": "Error fetching invoices",
  "errorOpeningInvoice": "Error opening invoice",
  "errorManageSubscription": "Error opening billing portal"
  ,
  "defaultProductName": "Time Control",
  "gpsLicensesSection": "GPS Tracking Licenses",
  "hoursLicensesSection": "Time Control Licenses",
  "noGpsLicenses": "No GPS tracking licenses",
  "noHoursLicenses": "No time control licenses",
  "noLicenses": "No active licenses",
  "products": {
    "time_control": "Time Control",
    "gps_tracking": "GPS Tracking"
  },
  "statusLabels": {
    "active": "Active",
    "trialing": "Trialing",
    "canceled": "Canceled",
    "past_due": "Past Due",
    "unpaid": "Unpaid",
    "incomplete": "Incomplete",
    "incomplete_expired": "Incomplete Expired"
  }
}

